<template>
  <LayoutAdmin @click="activeDropdown = false" :active-periode="activePeriodic">
    <section class="w-full px-8 mt-6 overflow-x-hiden">
      <section class="flex flex-row flex-wrap justify-between gap-x-2">
        <div class="flex justify-between w-full">
          <section class="flex items-center">
            <h1 class="text-2xl">Daftar Payrun Proses</h1>
            <ChoiseCompany v-if="!isLoadingCompany && companies.length"
              @selected:company="company = $event" :options="companies" :dataCompany="company" />
          </section>
          <Button class="px-6 py-2 mx-2 text-white rounded bg-primary h-max" @click="openModalAdd">Add Payrun
            Process</Button>
        </div>
        <section class="flex flex-wrap w-10/12 mt-6">
          <Dropdown title="Departement" :showDropdown="activeDropdown === 'departement'" :options="departements"
            property="dep_name" :selectedOption="filter.departement"
            @update:activeDropdown="changeDropdownActive('departement')" />
          <Dropdown title="Status" :options="empStatus" property="empstatus_name"
            :showDropdown="activeDropdown === 'employee_status'" @update:activeDropdown="(e) => changeDropdownActive('employee_status')
              " :selectedOption="filter.employment_status" />
          <Dropdown title="Payrun Type" :showDropdown="activeDropdown === 'payrun_type'" :options="payrunTypes"
            property="payrun_type" @update:activeDropdown="changeDropdownActive('payrun_type')" />
          <Dropdown title="Employee" :showDropdown="activeDropdown === 'employee'" :options="employees"
            property="emp_fullname" @update:activeDropdown="changeDropdownActive('employee')" />
        </section>
        <section class="relative w-full mb-4">
          <DetailBank v-for="(bank, index) in banksPayrun" :key="index" :bank-name="bank.bank.bank_name"
            :rek-debet="bank.bank.account_number" :total-record="bank.total_record"
            :total-amount="formatCurrency(bank.total_amount)" />
          <section class="flex justify-between p-4 mt-6 bg-white">
            <section class="bg-white">
              <Periodic :month-selected="monthSelected.text" :years-selected="yearsSelected"
                @on-previous-month="previousMonth" @on-next-month="nextMonth" />
            </section>
          </section>
          <Loading v-if="isLoading" />
          <TablePayrunProcess v-else :payruns-process="payrunsProcess" @on-update-status="onUpdateStatus" />
          <NoDataShowing v-if="payrunsProcess.length === 0" />
        </section>
      </section>
    </section>
  </LayoutAdmin>
  <ModalCreate v-if="modal.create.show" :title="'Create'" @close="closeModal" @on-search="query = $event"
    @on-process="onPayrunProcess" :month-selected="monthSelected.text" :years-selected="yearsSelected"
    :output-files="outputFiles" :items="companiesList" :banks-payrun="banksPayrun" :query="query" />
</template>

<script>
import LayoutAdmin from "@/components/Layout/Admin.vue";
import ChoiseCompany from "@/components/ChoiseCompany.vue";
import Dropdown from "@/components/Dropdown.vue";
import TablePayrunProcess from "@/components/PayrunProcess/TablePayrunProcess.vue";
import NoDataShowing from "@/components/NoDataShowing.vue";
import {
  getPayrunProcess,
  processPayrunProcess,
} from "@/actions/payrun-process";
import { GetAllCompanyEmployeeOptionsAPI } from "@/actions/company";
import { GetEmpStatusAPI } from "@/actions/emp-status";
import { GetDepartementAPI } from "@/actions/departement";
import { getPayrunTypes } from "@/actions/payruntype";
import { getBankPayrun } from "@/actions/bank-payrun";
import {
  GetAllEmployementAPI,
  updateEmployeePayrunStatus,
} from "@/actions/employment";
import { GetPeriodicAPI, GetPeriodicActiveAPI } from "@/actions/periodic";
import { getOutputFile } from "@/actions/output-file";
import decryptToken from "@/utils/decryptToken";
import { useToast } from "vue-toastification";
import Periodic from "@/components/Periodic.vue";
import Button from "@/components/Button.vue";
import DetailBank from "@/components/PayrunProcess/DetailBank.vue";
import ModalCreate from "@/components/PayrunProcess/ModalCreate.vue";
import Loading from "@/components/Loading.vue";
import moment from "moment";

export default {
  name: "PayrunProses",
  components: {
    LayoutAdmin,
    ChoiseCompany,
    Dropdown,
    Periodic,
    TablePayrunProcess,
    NoDataShowing,
    Button,
    DetailBank,
    ModalCreate,
    Loading,
  },
  setup() {
    const toast = useToast();
    return { toast, moment };
  },
  data() {
    return {
      activePeriodic: "-",
      superAdmin: null,
      isLoadingCompany: false,
      company: {},
      companies: [],
      empStatus: [],
      departements: [],
      payrunTypes: [],
      employees: [],
      filter: {
        employment_status: this.$store.state.filter.employment_status,
        designation: this.$store.state.filter.designation,
        departement: this.$store.state.filter.departement,
        workshifts: this.$store.state.filter.workshift,
        role: this.$store.state.filter.role,
        payrunType: "",
      },
      totalAmount: 0,
      activeDropdown: "",
      employeeFilter: false,
      monthSelected: {
        number: "",
        text: "",
      },
      periodics: [],
      payrunsProcess: [],
      banksPayrun: [],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      periodicId: null,
      modal: {
        create: {
          show: false,
        },
      },
      isLoading: true,
      outputFiles: [],
      query: "",
      periodicIds: [],
    };
  },
  mounted() {
    this.getRole();
    this.getAllCompany();
  },
  watch: {
    company: {
      handler() {
        this.getEmpStatus();
        this.getDepartement();
        this.getPayrunType();
        this.getEmployee();
        this.getPeriodic();
        this.handleGetPeriodicActive();
      },
      deep: true,
    },
  },
  computed: {
    yearsSelected() {
      return moment().format("YYYY");
    },
    companiesList() {
      return this.companies.filter((company) => {
        return this.query
          .toLowerCase()
          .split(" ")
          .every((v) => company.company_name.toLowerCase().includes(v));
      });
    },
  },
  methods: {
    async handleGetPeriodicActive() {
      const querySuperAdmin = `?company_id=${this?.company?._id}`;
      const response = await GetPeriodicActiveAPI(querySuperAdmin);
      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }
      console.log(response?.data);
      this.activePeriodic = response?.data?.periodic_month + " (" + response?.data?.periodic_start_date + " to " + response?.data?.periodic_end_date + ")";
    },
    async getAllCompany() {
      this.isLoadingCompany = true;
      const response = await GetAllCompanyEmployeeOptionsAPI();
      this.companies = response.data;
      this.company = response.data[0];
      this.isLoadingCompany = false;
      if (response.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }
    },
    async getEmpStatus() {
      const queryAdminSuper = `?company_id=${this.company?._id}`;
      const response = await GetEmpStatusAPI(queryAdminSuper);

      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }
      this.empStatus = response?.data;
    },
    async getDepartement() {
      const querySuperAdmin = `?company=${this.company?._id}`;
      const response = await GetDepartementAPI(querySuperAdmin);
      if (response.status === 401) {
        return this.$router.push("/login");
      }
      this.departements = response.data;
    },
    async getPayrunType() {
      const companyId = this.company._id;
      const { data, success, code, message } = await getPayrunTypes(companyId);

      if (success) {
        this.payrunTypes = data;
        this.isLoading = false;
      } else {
        if (code === 401) {
          return this.$router.push("/login");
        } else {
          this.toast.error(message);
        }
      }
    },
    async getEmployee() {
      const querySuperAdmin = `?company=${this.company._id}`;
      const response = await GetAllEmployementAPI(querySuperAdmin);
      if (response.status === 401) {
        return this.$router.push("/login");
      }
      this.employees = response?.data;
    },
    getRole() {
      const payload = decryptToken();
      this.superAdmin =
        payload?.role === "Super Admin" || payload?.role === "Group Admin";
    },
    async getPayrunProcess() {
      this.isLoading = true;
      const { data, message, success, code } = await getPayrunProcess({
        companyId: this.company?._id,
        periodicId: this.periodicId,
      });
      if (success) {
        this.payrunsProcess = data;
        let totalAmount = 0;
        this.payrunsProcess.forEach((payrunProcess) => {
          totalAmount += payrunProcess.payrun.payrun_net_salary;
        });
        this.totalAmount = totalAmount;
        this.isLoading = false;
      } else {
        if (code === 401) {
          return this.$router.push("/login");
        } else {
          this.toast.error(message);
        }
      }
    },
    async getPeriodic() {
      const companyId = this.company._id;
      const querySuperAdmin = `?company_id=${companyId}`;
      const response = await GetPeriodicAPI(querySuperAdmin);
      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }

      const filterActivePeriodic = response.data.filter(
        (period) => period.periodic_status === true
      )[0];
      const indexMonthActive = this.months.indexOf(
        filterActivePeriodic.periodic_month
      );
      this.monthSelected.number = indexMonthActive;
      this.monthSelected.text = this.months[indexMonthActive];
      this.periodics = response.data;
      this.periodicId = this.periodics.filter((period) => {
        return (
          period.periodic_month === this.monthSelected.text &&
          period.periodic_years === this.yearsSelected
        );
      })[0]._id;
      this.periodicIds.push(this.periodicId);
      this.getDetailBank(companyId);
      this.getPayrunProcess();
    },
    async getDetailBank(value) {
      const companyId = value;
      const { data, message, success, code } = await getBankPayrun({
        companyId,
        periodicId: this.periodicId,
      });
      this.banksPayrun = [];
      if (success) {
        const datas = data;
        datas.forEach((data) => {
          const findBankPayrun = this.banksPayrun.find((bankPayrun) => {
            return bankPayrun.bank._id === data.bank._id;
          });
          if (!findBankPayrun) {
            this.banksPayrun.push(data);
          }
        });
      } else {
        if (code === 401) {
          return this.$router.push("/login");
        } else {
          this.toast.error(message);
        }
      }
    },
    changeDropdownActive(id) {
      if (this.activeDropdown === id) {
        this.activeDropdown = false;
      } else {
        this.activeDropdown = id;
      }
    },
    formatCurrency(number) {
      const formatter = new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      });
      return formatter.format(Math.round(number));
    },
    openModalAdd() {
      this.modal.create.show = true;
      if (this.outputFiles.length === 0) {
        this.getOutputFile();
      }
    },
    previousMonth() {
      this.monthSelected.number--;
      if (this.monthSelected.number < 0) {
        this.monthSelected.number = 11;
        this.yearSelected--;
      }
      this.monthSelected.text = this.months[this.monthSelected.number];

      const periodicFilter = this.periodics.filter((periodic) => {
        return (
          periodic?.periodic_month === this.monthSelected.text &&
          periodic?.periodic_years === this.yearsSelected
        );
      })[0];
      if (periodicFilter) {
        this.periodicId = periodicFilter._id;
        this.getPayrunProcess();
      } else {
        this.payrunsProcess = [];
      }
    },
    nextMonth() {
      this.monthSelected.number++;
      if (this.monthSelected.number > 11) {
        this.monthSelected.number = 0;
        this.yearSelected++;
      }
      this.monthSelected.text = this.months[this.monthSelected.number];
      const periodicFilter = this.periodics.filter((periodic) => {
        return (
          periodic?.periodic_month === this.monthSelected.text &&
          periodic?.periodic_years === this.yearsSelected
        );
      })[0];
      if (periodicFilter) {
        this.periodicId = periodicFilter._id;
        this.getPayrunProcess();
      } else {
        this.payrunsProcess = [];
      }
    },
    async getOutputFile() {
      const { success, code, message, data } = await getOutputFile();
      if (success) {
        this.outputFiles = data;
      } else {
        if (code === 401) {
          return this.$router.push("/login");
        } else {
          this.toast.error(message);
        }
      }
    },
    closeModal() {
      this.modal.create.show = false;
    },
    async onPayrunProcess(payload) {
      const { message, success, code } = await processPayrunProcess(payload);
      if (success) {
        this.toast.success("Add payrun process successfully");
        this.closeModal();
        this.getPayrunProcess();
      } else {
        if (code === 401) {
          return this.$router.push("/login");
        } else {
          this.toast.error(message);
        }
      }
    },
    async onUpdateStatus(value, empId) {
      const { success, message, code } = await updateEmployeePayrunStatus({
        status: value,
        id: empId,
      });
      if (success) {
        this.toast.success(success);
        this.getPayrunProcess();
      } else {
        if (code === 401) {
          return this.$router.push("/login");
        } else {
          this.toast.error(message);
        }
      }
    },
  },
};
</script>
